import { Injectable } from '@angular/core';
import { RestProviderService } from '../rest-provider/rest-provider.service';
import { DynamicLoadingUtil } from '../../shared/helpers/dynamic-loading-util';
import { RequestModel } from '../../models/request/request-model';
import { Observable, throwError, BehaviorSubject } from 'rxjs';
import { map, filter, switchMap, catchError } from 'rxjs/operators';
import { PaginationModel } from 'src/app/models/search/pagination.model';
import { ProjectionFacetWrapperModel } from 'src/app/models/search/facet-projection-wrapper.model';
import { AdditionalSearchSettingsModel } from 'src/app/models/search/additional-search-settings.model';
import { Router } from '@angular/router';
import { SearchRightInfoModel } from '../../models/search/search-right-info-model';


@Injectable({
  providedIn: 'root'
})
export class SearchService {


  currentPreviewItemClicked = null;
  searchState: any = null;
  historySearchStateAdditionalFields: any = null;
  historySearchState: any = null;
  historySearchLatestFacets: any = null;
  historySearchMainSearchFieldValue: any = null;
  globalSearch: boolean = false;
  globalSearchType: string;

  facetsOrder: any[] = [];

  // settings for data grid and search component
  pageSize: number = 5;
  public currentPlaceHoldertitle: string;
  private searchRightInfo: Observable<SearchRightInfoModel[]>; // store the shared observable
  private searchRightInfoResponse: SearchRightInfoModel[];

  private defaultSearchUrl: string = "api/data/list";
  // search results
  private search: Observable<any[]>; // store the shared observable

  // projection and initial facets
  private searchProjectionAndFacets = new BehaviorSubject<ProjectionFacetWrapperModel>(undefined);
  currentSearchProjectionAndFacets = this.searchProjectionAndFacets.asObservable();

  // listener for search value change
  private newSearchValue = new BehaviorSubject(undefined);
  currentSearchValue = this.newSearchValue.asObservable();

  // listener for search pagination
  private pagination = new BehaviorSubject<PaginationModel>(undefined);
  currentPagination = this.pagination.asObservable();

  // listener for search page
  private searchPage = new BehaviorSubject(undefined);
  currentSearchPage = this.searchPage.asObservable();

  // listener for search facets - current facets that are included in search request
  private searchFacets = new BehaviorSubject(undefined);
  currentSearchFacets = this.searchFacets.asObservable();

  // facets that are availible for filtering on current listing page
  private availibleFacets = new BehaviorSubject(undefined);
  currentAvailibleFacets = this.availibleFacets.asObservable();

  // metamodel
  private metamodel = new BehaviorSubject(undefined);
  currentMetaModel = this.metamodel.asObservable();

  // sort field
  private sortFields = new BehaviorSubject(undefined);
  currentSortFields = this.sortFields.asObservable();

  // for enabling facets
  private enableFacets = new BehaviorSubject(undefined);
  currentEnableFacets = this.enableFacets.asObservable();

  // for additional search settings
  private additionalSearchSettings = new BehaviorSubject<AdditionalSearchSettingsModel>(undefined);
  currentAdditionalSearchSettings = this.additionalSearchSettings.asObservable();

  // listener for search event (if search was executed)
  private searchExecuted = new BehaviorSubject(undefined);
  currentSearchExecuted = this.searchExecuted.asObservable();


  private gridRestoredDefault = new BehaviorSubject(undefined);
  currentgridRestoredDefault = this.gridRestoredDefault.asObservable();

  private searchFieldsRestoredDefault = new BehaviorSubject(undefined);
  currentsearchFieldsRestoredDefault = this.searchFieldsRestoredDefault.asObservable();

  // listener for search event (if search was executed)
  private userSearchSettings = new BehaviorSubject(undefined);
  currentUserSearchSettings = this.userSearchSettings.asObservable();

  // listener for changing page size
  private pageS = new BehaviorSubject(undefined);
  currentPageSize = this.pageS.asObservable();

  // current search query  
  private currentSearchQuery = null;
  // current data grid display fields
  private currentGridDisplayFields = null;

  private currentCheckedBulkDocuments = null;

  constructor(private restProvider: RestProviderService, private router:Router) {
  }  

  setGridRestoredDefault(value) {
    this.gridRestoredDefault.next(value);
  }

  setSearchFieldsRestoredDefault(value) {
    this.searchFieldsRestoredDefault.next(value);
  }

  setEnableFacets(enable: boolean) {
    this.enableFacets.next(enable);
  }

  setAdditionalSearchSettings(settings: AdditionalSearchSettingsModel) {
    this.additionalSearchSettings.next(settings);
  }

  searchPerformed() {
    this.searchExecuted.next(true);
  }

  changeCurrentSearchSettings(currentSearchSettings: any, control: string) {
    this.userSearchSettings.next(
      {
        "Control": control,
        "Settings": currentSearchSettings
      });
  }

  changeSortFields(sortFields: any) {
    this.sortFields.next(sortFields);
  }  

  changePageSize(pagesize: number) {
    if (pagesize != null && typeof pagesize != "undefined") {
      this.pageSize = pagesize;
      this.pageS.next(pagesize);
    }
  }

  changeMetaModelEntities(metamodel: any) {
    this.metamodel.next(metamodel);
  }

  changeAvailibleFacets(facets: any) {
    this.availibleFacets.next(facets);
  }

  changeSearchFacets(facets: any) {
    this.searchFacets.next(facets);
  }

  setCurrentSearchQuery(searchQuery: any) {
    this.currentSearchQuery = searchQuery;
  }

  getCurrentSearchQuery() {
    return this.currentSearchQuery;
  }

  setCurrentCheckedBulkDocuments(currentCheckedBulkDocs: any[]) {
    this.currentCheckedBulkDocuments = currentCheckedBulkDocs;
  }

  getCurrentCheckedBulkDocument() {
    return this.currentCheckedBulkDocuments;
  }

  setCurrentGridDisplayFields(displayFields: any[]) {
    this.currentGridDisplayFields = displayFields;
  }

  getCurrentGridDisplayFields() {
    return this.currentGridDisplayFields;
  }

  changeSearchPage(pageNum: any) {
    if (pageNum == null || typeof pageNum == "undefined") {
      this.searchPage.next(undefined);
    } else {
      this.searchPage.next(pageNum + "");
    }
  }

  changeSearchProjectionAndFacets(projectionAndFacets: ProjectionFacetWrapperModel) {
    this.searchProjectionAndFacets.next(projectionAndFacets);
  }

  changePaginationInfo(paginationInfo: PaginationModel) {
    this.pagination.next(paginationInfo);
  }

  historySearchStatePresent(query: any){
    if (this.historySearchState != null && this.historySearchState["query"] != null && this.historySearchState["query"].data != null) {
      if (this.historySearchState["query"].data.ClassTypes[0] == query.ClassTypes[0] && this.historySearchState["url"] == window.location.href) {
        return true;
      } 
    } 
    return false;
  }

  getHistoryMainSearchFieldValue(){
    return this.historySearchMainSearchFieldValue;
  }

  getHistorySearchAdditionalFields(){
    let addFieldsHistory = [];

    if(this.historySearchStateAdditionalFields != null && typeof this.historySearchStateAdditionalFields != "undefined" && this.historySearchStateAdditionalFields.length > 0){
      for(var i = 0; i < this.historySearchStateAdditionalFields.length; i++){
        // add only those with searchvalues (because we need to show them on ui - biding)
        if(this.historySearchStateAdditionalFields[i].SearchValue != null && typeof this.historySearchStateAdditionalFields[i].SearchValue != "undefined" && this.historySearchStateAdditionalFields[i].SearchValue.length > 0){
          addFieldsHistory.push(
            {
              "Binding":this.historySearchStateAdditionalFields[i].Name,
              "Value":this.historySearchStateAdditionalFields[i].SearchValue
            });
        } else if (this.historySearchStateAdditionalFields[i]["CheckBoxState"] != null && typeof this.historySearchStateAdditionalFields[i]["CheckBoxState"] != "undefined" && this.historySearchStateAdditionalFields[i]["CheckBoxState"] != "novalue") {         
          addFieldsHistory.push(
            {
              "Binding":this.historySearchStateAdditionalFields[i].Name,
              "Value":this.historySearchStateAdditionalFields[i]["CheckBoxState"]
            });

        }  else if ((typeof this.historySearchStateAdditionalFields[i]["SearchValueFrom"] != "undefined" && this.historySearchStateAdditionalFields[i]["SearchValueFrom"] != "")
         || (typeof this.historySearchStateAdditionalFields[i]["SearchValueTo"] != "undefined" && this.historySearchStateAdditionalFields[i]["SearchValueTo"] != "")) {

          var from = "*";
          var to = "*";
  
          if (typeof this.historySearchStateAdditionalFields[i]["SearchValueFrom"] != "undefined" && this.historySearchStateAdditionalFields[i]["SearchValueFrom"] != "" && this.historySearchStateAdditionalFields[i]["SearchValueFrom"] != null) {
            from = this.historySearchStateAdditionalFields[i]["SearchValueFrom"];
          }
  
          if (typeof this.historySearchStateAdditionalFields[i]["SearchValueTo"] != "undefined" && this.historySearchStateAdditionalFields[i]["SearchValueTo"] != "" && this.historySearchStateAdditionalFields[i]["SearchValueTo"] != null) {
            to = this.historySearchStateAdditionalFields[i]["SearchValueTo"];
          }
  
          addFieldsHistory.push(
            {
              "Binding":this.historySearchStateAdditionalFields[i].Name,
              "ValueFrom":from,
              "ValueTo":to
            });
        }       
      }
    }

    return addFieldsHistory;
  }

  performSearch(query: any, customSearchUrl: string, additionalFieldsInfo: any, mainSearchValue: any) {

    let searchUrl = this.defaultSearchUrl;

    if (customSearchUrl != null && typeof customSearchUrl != "undefined" && customSearchUrl.trim() != "") {
      searchUrl = customSearchUrl;
    }

    var reqModel = new RequestModel;

    if (this.historySearchState != null && this.historySearchState["query"] != null && this.historySearchState["query"].data != null) {
      if (this.historySearchState["query"].data.ClassTypes[0] == query.ClassTypes[0] && this.historySearchState["url"] == window.location.href) {
        reqModel = this.historySearchState["query"];
      } else {
        reqModel.url = searchUrl;
        reqModel.data = query;
        this.searchState = reqModel;
        this.historySearchStateAdditionalFields = additionalFieldsInfo;  
        this.historySearchMainSearchFieldValue = mainSearchValue;      
      }
    } else {
      reqModel.url = searchUrl;
      reqModel.data = query;
      this.searchState = reqModel;
      this.historySearchStateAdditionalFields = additionalFieldsInfo;      
      this.historySearchMainSearchFieldValue = mainSearchValue;
    }

    this.search = this.restProvider.getDataPOST<any[]>(reqModel).
      pipe(
        map((data: any[]) => {
          this.historySearchState = null;
          return data;
        }), catchError((error:any) =>{
            //Observable.throw('Error while retrieving data from the server - ' + (error.json().errorMessage || 'Server error'))
            throw Observable.create(error);
          }
        ));


    return this.search;

  }

  getAllowedSearchClasses(searchType: string){

    var reqModel = new RequestModel;    
    reqModel.url = "/api/user/allowedsearchclass";    
    reqModel.data = {
      "GlobalSearchType": searchType      
    }

    this.searchRightInfo = this.restProvider.getDataPOST<SearchRightInfoModel[]>(reqModel).
    pipe(
      map((data: SearchRightInfoModel[]) => {
      this.searchRightInfoResponse = data;
        return data;
      }), catchError(error => {
        return throwError('User service error!', error)
      }));

  return this.searchRightInfo;
  }

  changeSearchValue(value: any) {
    this.newSearchValue.next(value);
  }

  setLatestHistorySearchFacets(currentFacets,classType, url){
    this.historySearchLatestFacets = 
    {
      "Facets":currentFacets,
      "url":url,
      "classType":classType
    };

    return this.historySearchLatestFacets;
  }

}
